// this file is generated by update_shopify_store_data.py at 2026-01-26 20:18:19.905041
var courses = [
    {
        "course_id": "CAB429A7-29F9-EF11-9999-005056A7D719",
        "course_version": 2,
        "name": "Activated Insights: OASIS Series for Professionals",
        "course_type": 32,
        "author_information": "",
        "description": "Curated by Home Care Pulse, this value-based library goes deeper into the OASIS E regulations. Designed to increase your knowledge of CMS Home Care regulations related to the Centers for Medicare and Medicaid Services (CMS) Outcome and Assessment Information Set (OASIS). This bundle includes the following courses: OASIS D1 to OASIS E overview, OASIS E Basics, and OASIS E Section by Section. The bundle also includes the individually assignable OASIS E Sections.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "C94B114A-29F9-EF11-9999-005056A7D719",
                "course_category_name": "Activated Insights - OASIS Series for Professionals - Curriculum",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "6BD6A92F-F492-EE11-9986-005056A7B10E",
                "course_version": 4,
                "name": "OASIS-E1 Section GG: Functional Abilities and Goals",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers Part 2 of the Functional Abilities and Goals items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4F09826A-DA92-EE11-9986-005056A7B10E",
                "course_version": 4,
                "name": "OASIS-E1 Section A Part 2: Administrative Information",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the second half of the administrative information items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2B3C5705-9EF9-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section A Part 1: Administrative Information Patient Tracking",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the first half of the Administrative Information items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "629C27C9-06FB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section G: Functional Status",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers Part 1 of the Functional Status items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "76F6BD9D-29FB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section M: Skin Conditions",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the skin condition items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "02FC4A9B-4FFA-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section E: Behavior",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the behavior items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B7AF0391-01FB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section F: Preferences for Customary Routine Activities",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the Preferences for Customary Routine Activities within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "8D822223-14FB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section H: Bowel and Bladder",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers Bowel and Bladder items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B0E60C5F-16FB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section I: Active Diagnoses",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers Active Diagnoses items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "7D52A9CC-A0F9-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section B: Hearing, Speech, and Vision",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the hearing, speech, and vision items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3293E8AB-A6F9-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section C: Cognitive Patterns",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the cognitive patterns items within OASIS-E1. The course highlights the items found in this section, pointers for handling common challenges in completing those items, and resources available to help ensure success. This course is appropriate for clinicians and leaders new to home health as well as more seasoned staff who want to ensure their skills are up to date with the new OASIS-E1 assessments.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6D93814E-17FB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section J: Health Conditions",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the health conditions items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "190DFC0A-4EFA-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section D: Mood",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the mood items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F58135B2-24FB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section K: Swallowing/Nutrition",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the swallowing and nutrition items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4B644BED-2AFB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section N: Medications",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the medication items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "51467727-2DFB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section O: Special Treatments, Procedures, and Programs",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the special treatments, procedures, and programs items within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "838EB3A5-2DFB-ED11-8103-005056B13A46",
                "course_version": 5,
                "name": "OASIS-E1 Section P: Participation in Assessment and Goal Setting",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers Participation in Assessment and Goal Setting within OASIS-E1.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate the ability to distinguish between accurately and inaccurately completed OASIS-E1 assessments in each section of OASIS-E1.</li>\r\n    <li>Recognize common challenges associated with specific OASIS-E1 items.</li>\r\n    <li>Identify resources available for use when questions arise during OASIS-E1 completion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4ADC5A2E-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Clinical Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0D7D20DC-1661-ED11-80F6-005056B16DD5",
                "course_version": 5,
                "name": "OASIS Basics",
                "course_type": 1,
                "author_information": "Activated Insights",
                "description": "This course covers the intent and purpose of OASIS and provides new and experienced home health clinicians and leaders with the knowledge needed to successfully navigate OASIS.",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:&nbsp;</p>\r\n<ul>\r\n    <li>Describe the intent and purpose of OASIS-E.&nbsp;</li>\r\n    <li>Correctly apply general OASIS-E1conventions in patient scenarios.&nbsp;</li>\r\n    <li>Identify the three types of data measures collected via the OASIS-E1 assessment.&nbsp;</li>\r\n    <li>List three resources available for help in completing OASIS-E1.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                        "course_category_name": "Activated Insights: Home and Hospice Library",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A729A54C-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights - OASIS Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AF4AAD6D-D792-EE11-9986-005056A7B10E",
                        "course_category_name": "Activated Insights: OASIS Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                        "course_category_name": "Activated Insights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                        "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9460E876-29F9-EF11-9999-005056A7D719",
                        "course_category_name": "Activated Insights - OASIS Series for Professionals - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Activated Insights is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.<br />\r\n<br />\r\nTo obtain contact hours participants must view the entire course and pass the post-test with a score of 80% or greater. Upon successful completion, [CreditUnits] contact hours will be awarded to nurses. Provider approved by the California Board of Registered Nursing, Provider # CA CEP17757 for [CreditUnits] contact hours. Post-learning survey completion is required for the course to be marked as complete in the system.<br />\r\n<br />\r\nActivated Insights reports the absence of relevant financial relationships to disclose for all persons in control of the content of this course. There was no commercial support for the development and implementation of this program.<br />\r\n<br />\r\nThe course has been reviewed for evidence of bias and Activated Insights guarantees the absence of bias. At Activated Insights, we acknowledge and respect all gender identities that exist today. Gender-specific terms and pronouns may be used in order to ease the text flow of our training.&nbsp;",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];